import { CommonError } from '../../types';
import { TradingTicketActions } from './actions';
import {
    FETCH_TRENDING_TICKET_FAILURE,
    FETCH_TRENDING_TICKET_REQUEST,
    FETCH_TRENDING_TICKET_SUCCESS,
} from './constants';
import { cpCode, monthChangePersent, price, MostMatched, TrendingTicketType } from './types';

export interface TrendingTicketState {
    trendingTickets: TrendingTicketType[];
    loading: boolean;
    error: CommonError | null;
}

const initialState: TrendingTicketState = {
    trendingTickets: [
        {
            [price]: 0,
            [monthChangePersent]: 0,
            [cpCode]: 'N/A',
            [MostMatched]: 0,
        },
    ],
    loading: false,
    error: null,
};

export const TrendingTicketReducer = (state = initialState, action: TradingTicketActions): TrendingTicketState => {
    switch (action.type) {
        case FETCH_TRENDING_TICKET_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_TRENDING_TICKET_SUCCESS:
            return {
                ...state,
                loading: false,
                trendingTickets: action.payload,
            };

        case FETCH_TRENDING_TICKET_FAILURE:
            return { ...state, loading: false, error: null };

        default:
            return state;
    }
};
